import React from 'react';
import { FaFacebook, FaTwitter, FaInstagram, FaLinkedin, FaHeart, FaShieldAlt, FaAward, FaHeadset } from 'react-icons/fa';

const Footer = () => {

  // Scroll to top smoothly
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <>
      {/* Trust Badges Section - Added above footer */}
      <div className="trust-badges bg-light py-4">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-10">
              <div className="row text-center">
                <div className="col-md-3 mb-3 mb-md-0">
                  <div className="d-flex align-items-center justify-content-center">
                    <FaShieldAlt className="text-primary me-2" size={24} />
                    <span className="small">Secure & Reliable</span>
                  </div>
                </div>
                <div className="col-md-3 mb-3 mb-md-0">
                  <div className="d-flex align-items-center justify-content-center">
                    <FaAward className="text-warning me-2" size={24} />
                    <span className="small">Premium Quality Technology</span>
                  </div>
                </div>
                <div className="col-md-3 mb-3 mb-md-0">
                  <div className="d-flex align-items-center justify-content-center">
                    <FaHeadset className="text-info me-2" size={24} />
                    <span className="small">24/7 Support for Students </span>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="d-flex align-items-center justify-content-center">
                    <FaHeart className="text-danger me-2" size={24} />
                    <span className="small">Students Love</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Main Footer */}
      <footer className="footer bg-dark text-white pt-5 pb-3 position-relative">
        {/* Animated background elements */}
        <div className="footer-bg-elements">
          <div className="circle circle-1"></div>
          <div className="circle circle-2"></div>
          <div className="circle circle-3"></div>
        </div>
        
        <div className="container position-relative">
          <div className="row">
            {/* About Us Section */}
            <div className="col-lg-4 col-md-6 mb-4 mb-md-0">
              <h5 className="text-uppercase fw-bold mb-3 footer-title">About Us</h5>
              <p className="text-light footer-description">
                GSK College is dedicated to providing quality education Technology 
                and fostering innovation through modern teaching methodologies and industry-focused programs.
              </p>
              

              {/* Newsletter Subscription */}
              <div className="newsletter mt-4">
                <h6 className="text-uppercase small fw-bold mb-2">Stay Connected with Us</h6>
                <div className="input-group">
                  <input 
                    type="email" 
                    className="form-control form-control-sm" 
                    placeholder="Enter your email" 
                    aria-label="Enter your email"
                  />
                  <button className="btn btn-primary btn-sm" type="button">
                    Subscribe
                  </button>
                </div>
              </div>
            </div>
            
            {/* Quick Links Section */}
            <div className="col-lg-2 col-md-6 mb-4 mb-md-0">
              <h5 className="text-uppercase fw-bold mb-3 footer-title">Quick Links</h5>
              <ul className="list-unstyled">
                <li className="mb-2">
                  <a href="/" className="text-light footer-link">
                    <span className="link-icon">→</span> Courses
                  </a>
                </li>
                <li className="mb-2">
                  <a href="/about" className="text-light footer-link">
                    <span className="link-icon">→</span> Admissions
                  </a>
                </li>
                <li className="mb-2">
                  <a href="/services" className="text-light footer-link">
                    <span className="link-icon">→</span> Faculty
                  </a>
                </li>
                <li className="mb-2">
                  <a href="/contact" className="text-light footer-link">
                    <span className="link-icon">→</span> Student Portal
                  </a>
                </li>
              </ul>
            </div>
            
            {/* Contact Info Section */}
            <div className="col-lg-3 col-md-6 mb-4 mb-md-0">
              <h5 className="text-uppercase fw-bold mb-3 footer-title">Contact Info</h5>
              <ul className="list-unstyled">
                <li className="mb-2 contact-item d-flex align-items-start text-light">
                  <span className="me-2">📍</span>
                  <span>Hanumanganj Fatuhan Road Prayagraj, UP</span>
                </li>
                <li className="mb-2 contact-item d-flex align-items-start text-light">
                  <span className="me-2">📧</span>
                  <span>gskinstitute2225@gmail.com</span>
                </li>
                <li className="mb-2 contact-item d-flex align-items-start text-light">
                  <span className="me-2">📞</span>
                  <span>+91 9807664383 ,6393922633</span>

                </li>
                <li className="mb-2 contact-item d-flex align-items-start text-light">
                  <span className="me-2">🕒</span>
                  <span>Mon - Sat: 7AM - 6:30PM</span>
                </li>
              </ul>
            </div>
            
            {/* Social Media Section */}
            <div className="col-lg-3 col-md-6">
              <h5 className="text-uppercase fw-bold mb-3 footer-title">Follow Us</h5>
              <div className="social-icons d-flex mb-4">
                <a 
                  href="https://www.facebook.com/share/19sFpSGG8u/" 
                  className="text-white social-icon me-2"
                  aria-label="Facebook"
                >
                  <FaFacebook size={18} />
                </a>
                <a 
                  href="https://twitter.com/" 
                  className="text-white social-icon me-2"
                  aria-label="Twitter"
                >
                  <FaTwitter size={18} />
                </a>
                <a 
                  href="https://www.instagram.com/gskcollege221505?igsh=MW95NnBlemRuODZkNA==" 
                  className="text-white social-icon me-2"
                  aria-label="Instagram"
                >
                  <FaInstagram size={18} />
                </a>
                <a 
                  href="https://www.linkedin.com/in/abhishek-prajapati-09a455271/" 
                  className="text-white social-icon"
                  aria-label="LinkedIn"
                >
                  <FaLinkedin size={18} />
                </a>
              </div>
              
              {/* App Download Badges */}
              <div className="app-download">
                <h6 className="text-uppercase small fw-bold mb-2">Download Our App</h6>
                <div className="d-flex">
                  <div className="app-badge me-2">
                    <div className="badge-placeholder bg-secondary rounded p-2 d-flex align-items-center justify-content-center">
                      <span className="small">App Store</span>
                    </div>
                  </div>
                  <div className="app-badge">
                    <div className="badge-placeholder bg-secondary rounded p-2 d-flex align-items-center justify-content-center">
                      <span className="small">Play Store</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <hr className="my-4 bg-secondary" />
          
          {/* Copyright Section */}
          <div className="row align-items-center">
            <div className="col-md-6 text-center text-md-start mb-2 mb-md-0">
              <p className="m-0 text-light small">
                &copy; {new Date().getFullYear()} GSK College. Affiliated By: NIELIT All Rights Reserved.
              </p>
            </div>
            <div className="col-md-6 text-center text-md-end">
              <div className="footer-legal-links">
                <a href="/privacy" className="text-light small me-3">Privacy Policy</a>
                <a href="/terms" className="text-light small me-3">Terms of Service</a>
                <a href="/cookies" className="text-light small">Cookie Policy</a>
              </div>
            </div>
          </div>
        </div>
        
        {/* Back to Top Button with Animated Arrow Image */}
        <button 
          onClick={scrollToTop}
          className="btn btn-primary back-to-top-btn"
          aria-label="Back to top"
        >
          <div className="arrow-container">
            <img 
              src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='white' width='24px' height='24px'%3E%3Cpath d='M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z'/%3E%3Cpath d='M0 0h24v24H0z' fill='none'/%3E%3C/svg%3E" 
              alt="Up arrow" 
              className="arrow-image"
            />
          </div>
        </button>
        
        <style jsx>{`
          .trust-badges {
            border-bottom: 1px solid #e9ecef;
          }
          
          .footer {
            overflow: hidden;
          }
          
          .footer-bg-elements {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            pointer-events: none;
            z-index: 0;
          }
          
          .circle {
            position: absolute;
            border-radius: 50%;
            opacity: 0.05;
            background: linear-gradient(45deg, #6c5ce7, #a29bfe);
          }
          
          .circle-1 {
            width: 200px;
            height: 200px;
            top: -100px;
            right: -50px;
          }
          
          .circle-2 {
            width: 150px;
            height: 150px;
            bottom: 50px;
            left: -50px;
          }
          
          .circle-3 {
            width: 100px;
            height: 100px;
            top: 50%;
            left: 30%;
          }
          
          .footer-title {
            position: relative;
            display: inline-block;
          }
          
          .footer-title::after {
            content: '';
            position: absolute;
            bottom: -8px;
            left: 0;
            width: 40px;
            height: 2px;
            background: linear-gradient(90deg, #6c5ce7, #00cec9);
            transition: width 0.3s ease;
          }
          
          .footer-title:hover::after {
            width: 100%;
          }
          
          .footer-link {
            transition: all 0.3s ease;
            position: relative;
            text-decoration: none;
            display: inline-block;
            color: rgba(255, 255, 255, 0.9) !important;
          }
          
          .footer-link .link-icon {
            opacity: 1;
            transform: translateX(0);
            transition: all 0.3s ease;
            display: inline-block;
            margin-right: 5px;
          }
          
          .footer-link:hover {
            color: #ffffff !important;
            transform: translateX(5px);
          }
          
          .footer-link:hover .link-icon {
            color: #00cec9;
          }
          
          .social-icon {
            transition: all 0.3s ease;
            padding: 10px;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 40px;
            height: 40px;
            background: rgba(255, 255, 255, 0.1);
          }
          
          .social-icon:hover {
            transform: translateY(-5px);
            background: linear-gradient(45deg, #6c5ce7, #00cec9);
            box-shadow: 0 5px 15px rgba(108, 92, 231, 0.4);
          }
          
          .contact-item {
            transition: all 0.3s ease;
            padding: 5px 0;
            color: rgba(255, 255, 255, 0.9) !important;
          }
          
          .contact-item:hover {
            color: #ffffff !important;
            background: rgba(255, 255, 255, 0.1);
            padding: 5px 10px;
            border-radius: 4px;
          }
          
          .footer-description {
            transition: all 0.3s ease;
            line-height: 1.6;
            color: rgba(255, 255, 255, 0.9) !important;
          }
          
          .footer-description:hover {
            color: #ffffff !important;
            transform: none;
          }
          
          .back-to-top-btn {
            position: fixed;
            bottom: 20px;
            left: 20px;
            width: 50px;
            height: 50px;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            z-index: 9999;
            cursor: pointer;
            background: linear-gradient(135deg, #6c5ce7, #00cec9);
            border: none;
            box-shadow: 0 4px 20px rgba(108, 92, 231, 0.4);
            transition: all 0.3s ease;
            padding: 0;
          }

          .back-to-top-btn:hover {
            transform: scale(1.1);
            box-shadow: 0 8px 25px rgba(108, 92, 231, 0.6);
            background: linear-gradient(135deg, #00cec9, #6c5ce7);
          }

          .arrow-container {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
            height: 100%;
          }

          .arrow-image {
            width: 24px;
            height: 24px;
            animation: bounce 1.5s infinite;
            filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3));
          }

          @keyframes bounce {
            0%, 100% {
              transform: translateY(0);
            }
            50% {
              transform: translateY(-5px);
            }
          }

          .back-to-top-btn:hover .arrow-image {
            animation: bounceFast 0.8s infinite;
            filter: drop-shadow(0 0 8px rgba(255, 255, 255, 0.8));
          }

          @keyframes bounceFast {
            0%, 100% {
              transform: translateY(0);
            }
            50% {
              transform: translateY(-7px);
            }
          }

          .footer-legal-links a {
            transition: all 0.3s ease;
            text-decoration: none;
          }
          
          .footer-legal-links a:hover {
            color: #fff !important;
            text-decoration: underline;
          }
          
          .newsletter .form-control {
            background: rgba(255, 255, 255, 0.1);
            border: 1px solid rgba(255, 255, 255, 0.2);
            color: white;
          }
          
          .newsletter .form-control::placeholder {
            color: rgba(255, 255, 255, 0.6);
          }
          
          .app-badge {
            transition: all 0.3s ease;
          }
          
          .app-badge:hover {
            transform: translateY(-3px);
          }
          
          .badge-placeholder {
            width: 100px;
            height: 40px;
            cursor: pointer;
            transition: all 0.3s ease;
          }
          
          .badge-placeholder:hover {
            background: linear-gradient(45deg, #6c5ce7, #00cec9) !important;
          }

          /* Responsive adjustments */
          @media (max-width: 768px) {
            .back-to-top-btn {
              bottom: 15px;
              left: 15px;
              width: 45px;
              height: 45px;
            }
            
            .arrow-image {
              width: 20px;
              height: 20px;
            }
          }
        `}</style>
      </footer>
    </>
  );
};

export default Footer;